<template>
    <label class="choice__label" :class="[{ '-selected': isSelected }, labelClass]">
        <span v-if="choice.level == 'title-separator'" v-html="choice.label" class="choice__label__title-separator"></span>
        <span v-else>
            <input type="checkbox"
                class="checkbox-input"
                :value="choice.value"
                :checked="isSelected"
                :disabled="disabled || readOnly"
                @change.stop="changeValue"
                :tabindex="questionIndex"
                :aria-labelledby="rowID"
            >
            <span v-once v-html="choice.label" :id="rowID"></span> <span class="choice__tip" v-if="isSelected" v-html="tip"></span>
        </span>
    </label>
</template>

<script>
import { forEach, isObject, isArray, find } from 'lodash';
import { TRIGGER_TYPE_ANSWER_TIP } from '../../constants';
// import { matrixRowMixin } from './mixins/matrix-row-mixin';

export default {
    name: 'checkbox-group-row',

    props: {
        questionIndex: Number,
        columns: Array,
        choice: [Object,Array],
        row: String,
        uukey: String,
        triggers: Object,
        answer: [String, Object, Array],
        disabled: Boolean,
        readOnly: Boolean,
    },

    data()
    {
        return {
            tip: null,
        };
    },

    beforeMount()
    {
        forEach(this.triggers, (values, key) =>
        {
            switch(key)
            {
                case TRIGGER_TYPE_ANSWER_TIP:
                    this.parseTipTrigger(values);
                    break;
                default:
                    break;
            }
        });
    },

    computed: {
        rowID()
        {
            return `r_${this.uukey}_${this.choice.value}`;
        },

        isSelected()
        {
            if (this.disabled)
            {
                return false;
            }
            if (isArray(this.answer))
            {
                return (this.answer.indexOf(this.choice.value) >= 0);
            }
            if (isObject(this.answer))
            {
                return this.answer[this.choice.value];
            }
            return (this.answer == this.choice.value);
        },
        labelClass()
        {
            if (this.choice.level)
            {
                switch (this.choice.level)
                {
                    case 'indent-1':
                    case 'indent-2':
                        return `choice__checkbox-${this.choice.level}`;
                    default:
                        break;
                }
            }
            return '';
        },
    },

    methods: {
        changeValue($event)
        {
            const $target = $($event.target);
            this.$parent.changeValue($target.is(':checked'), this.choice.value);
        },

        parseTipTrigger(values)
        {
            forEach(values, (text, targetAnswer) =>
            {
                if (targetAnswer == this.choice.value)
                {
                    this.tip = text;
                }
            });
        },
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/checkbox-group-row.vue